/**
 * @format
 * @description Financial Full-chart section page
 */
export default {
  // available-slots-for-tier: {
  //   ldbd: [],
  // },
  mobile: {},
  portrait: {
    ldbd: [[728, 90]]
  },
  landscape: {
    ldbd: [[728, 90]]
  },
  desktop: {
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66]
    ]
  }
};
